import { Skeleton } from '@mui/material';
import React from 'react';

export default () => (
	<>
		<Skeleton
			sx={{ height: 250, marginTop: 10 }}
			animation="wave"
			variant="rectangular"
		/>
		<Skeleton
			sx={{ height: 180, marginTop: 15 }}
			animation="wave"
			variant="rectangular"
		/>
	</>
);
